import { jobOrderColNm } from "constants/jobOrderConstant";
import { subcontractExpenseColNm, subcontractInvoiceColNm, whtPayrTypOptions } from "constants/subcontractConstant";
import dayjs from "dayjs";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { numberFormat } from "utils";
import { Button, IconButton } from "@mui/material";
import { AddCircleRounded, ArticleRounded, PrintRounded, ReceiptRounded, RemoveCircleRounded } from "resource/muiImport";

const jobOrderCoreColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "ลำดับ",
    width: 40,
    align: "center",
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 70,
  },
  {
    field: "AptTm",
    headerName: jobOrderColNm.AptTm,
    width: 100,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params) => params.value ? params.value.format("DD/MM HH:mm") : "-",
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 120,
  },
  {
    field: "Bkg",
    headerName: jobOrderColNm.Bkg,
    width: 120,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    width: 60,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    width: 160
  },
  {
    field: "RcptNm",
    headerName: "ใบเสร็จ",
    width: 40,
    align: "center",
    renderCell: ({row}) => (
      <IconButton sx={{ p:0}} >
        <ReceiptRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "ScSNms",
    headerName: "ผู้รับผิดชอบ",
    width: 80,
  },
  {
    field: "StsNm",
    headerName: "หน้าที่",
    width: 80,
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุใบงาน",
    flex: 1,
    minWidth: 120
  },
  {
    field: "ScInvNos",
    headerName: subcontractInvoiceColNm.ScInvNo,
    width: 120,
  },
  {
    field: "XpssDocNums",
    headerName: subcontractInvoiceColNm.XpssDocNum,
    width: 120,
  },
]
export const jobOrderColumns = [
  ...jobOrderCoreColumns,
  {
    field: "Remove",
    headerName: "",
    width: 50,
    renderCell: () => (
      <IconButton>
        <RemoveCircleRounded />
      </IconButton>
    )
  }
]
export const jobOrderSearchColumns = [
  ...jobOrderCoreColumns,
  {
    field: "Add",
    headerName: "",
    width: 50,
    renderCell: () => (
      <IconButton>
        <AddCircleRounded color="primary" />
      </IconButton>
    )
  }
]

export const expenseColumns = (handleDeleteExpenseRow, whtTypeCombo = [], handlePrintWht) => [
  {
    field: "ExpNm",
    headerName: subcontractExpenseColNm.ExpNm,
    width: 180,
  },
  {
    field: "UntPr",
    headerName: subcontractExpenseColNm.UntPr,
    width: 90,
    align: "right",
    valueGetter: (params) => +params.value,
    valueFormatter: (params) => numberFormat(params.value)
  },
  {
    field: "Qty",
    headerName: subcontractExpenseColNm.Qty,
    width: 60,
    align: "center",
  },
  {
    field: "Total",
    headerName: subcontractExpenseColNm.Total,
    width: 90,
    align: "right",
    valueGetter: (params) => +params.value,
    valueFormatter: (params) => numberFormat(params.value)
  },
  {
    field: "VatPrct",
    headerName: subcontractExpenseColNm.VatPrct,
    width: 50,
    align: "right",
    valueFormatter: (params) => {
      return `${params.value}%`;
    }
  },
  {
    field: "WhtPrct",
    headerName: subcontractExpenseColNm.WhtPrct,
    width: 50,
    align: "right",
    valueFormatter: (params) => {
      return `${params.value}%`;
    }
  },
  {
    field: "IsOwnRcpt",
    headerName: subcontractExpenseColNm.IsOwnRcpt,
    width: 100,
    align: "center",
    valueFormatter: (params) => {
      return params.value === 1 ? `ใบเสร็จบริษัท` : `ใบเสร็จลูกค้า`;
    },
  },
  {
    field: "WhtPayrTyp",
    headerName: subcontractExpenseColNm.WhtPayrTyp,
    width: 100,
    align: "center",
    valueFormatter: (params) => whtPayrTypOptions.find(v => v.value === params.value)?.label || "-",
  },
  {
    field: "WhtTypNm",
    headerName: subcontractExpenseColNm.WhtTypNm,
    width: 80,
    align: "center",
  },
  {
    field: "SupSNm",
    headerName: subcontractExpenseColNm.SupSNm,
    width: 90,
  },
  {
    field: "Print",
    headerName: "WHT",
    width: 40,
    align: "center",
    renderCell: ({ row }) => (
      row.WhtPrct > 0 &&
      <IconButton onClick={() => handlePrintWht && handlePrintWht(row)}>
        <PrintRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "Rmk",
    headerName: subcontractExpenseColNm.Rmk,
    flex: 1
  },
  {
    field: "ScInvNos",
    headerName: subcontractInvoiceColNm.ScInvNo,
    width: 120,
  },
  {
    field: "XpssDocNums",
    headerName: subcontractInvoiceColNm.XpssDocNum,
    width: 120,
  },
  {
    hide: handleDeleteExpenseRow ? false : true,
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<RemoveCircleRounded />}
        label="Delete"
        onClick={() => handleDeleteExpenseRow(params.row)}
      />
    ],
  }
]

export const scInvColumns = (handlePVNoClick) => [
  {
    field: 'No',
    headerName: 'ลำดับ',
    width: 70,
    align: 'center',
  },
  {
    field: 'ScSNm',
    headerName: subcontractInvoiceColNm.ScSNm,
    width: 130,
  },
  {
    field: 'ScInvDte',
    headerName: subcontractInvoiceColNm.ScInvDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params) => params.value ? params.value.format("DD/MM/YYYY") : "-",
  },
  {
    field: 'ScInvNo',
    headerName: subcontractInvoiceColNm.ScInvNo,
    width: 120,
  },
  {
    field: 'XpssDocNum',
    headerName: subcontractInvoiceColNm.XpssDocNum,
    width: 130,
  },
  {
    field: 'XpssDocDte',
    headerName: subcontractInvoiceColNm.XpssDocDte,
    width: 130,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params) => params.value ? params.value.format("DD/MM/YYYY") : "-",
  },
  {
    field: 'NumJobOrd',
    headerName: subcontractInvoiceColNm.NumJobOrd,
    width: 100,
    align: "center"
  },
  {
    field: 'OwnRcptAmnt',
    headerName: subcontractInvoiceColNm.OwnRcptAmnt,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'CusRcptAmnt',
    headerName: subcontractInvoiceColNm.CusRcptAmnt,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'Total',
    headerName: subcontractInvoiceColNm.Total,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: "WhtPr",
    headerName: subcontractExpenseColNm.WhtPr,
    width: 90,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: "PayAmnt",
    headerName: subcontractExpenseColNm.PayAmnt,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'PVNo',
    headerName: subcontractInvoiceColNm.PVNo,
    width: 140,
    renderCell: (params) => (
      params.row.PVId &&
      <Button sx={{ width: "100%" }} variant="contained"
        onClick={() => handlePVNoClick(params.row.PVId)}>
        {params.value}
      </Button>
    )
  },
  {
    field: 'Rmk',
    headerName: subcontractInvoiceColNm.Rmk,
    flex: 1,
  }
]

export const scPvInvColumns = [
  {
    field: 'No',
    headerName: 'ลำดับ',
    width: 70,
    align: 'center',
  },
  {
    field: 'ScInvNo',
    headerName: subcontractInvoiceColNm.ScInvNo,
    width: 120,
  },
  {
    field: 'ScInvDte',
    headerName: subcontractInvoiceColNm.ScInvDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params) => params.value ? params.value.format("DD/MM/YYYY") : "-",
  },
  {
    field: 'XpssDocNum',
    headerName: subcontractInvoiceColNm.XpssDocNum,
    width: 130,
  },
  {
    field: 'NumJobOrd',
    headerName: subcontractInvoiceColNm.NumJobOrd,
    width: 100,
    align: "center"
  },
  {
    field: 'OwnRcptAmnt',
    headerName: subcontractInvoiceColNm.OwnRcptAmnt,
    width: 110,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'CusRcptAmnt',
    headerName: subcontractInvoiceColNm.CusRcptAmnt,
    width: 110,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'Total',
    headerName: subcontractInvoiceColNm.Total,
    headerAlign: "center",
    type: "number",
    width: 110,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: "WhtPr",
    headerName: subcontractExpenseColNm.WhtPr,
    headerAlign: "center",
    width: 90,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: "PayAmnt",
    headerName: subcontractExpenseColNm.PayAmnt,
    width: 100,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'Rmk',
    headerName: subcontractInvoiceColNm.Rmk,
    flex: 1,
  }
]

export const scPVReportCols = [
  {
    field: 'ScInvNo',
    headerName: "เลขที่ใบแจ้งหนี้",
    width: 110,
  },
  {
    field: 'ScInvDte',
    headerName: subcontractInvoiceColNm.ScInvDte,
    width: 110,
    type: "date",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params) => params.value ? params.value.format("DD/MM/YYYY") : "-",
  },
  {
    field: 'CusSNm',
    headerName: subcontractInvoiceColNm.CusSNm,
    flex: 1,
  },
  {
    field: 'AptTm',
    headerName: subcontractInvoiceColNm.AptTm,
    width: 160,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params) => params.value ? params.value.format("DD/MM/YYYY HH:mm") : "-",
  },
  {
    field: 'ContNo',
    headerName: subcontractInvoiceColNm.ContNo,
    width: 120,
  },
  {
    field: 'Loc',
    headerName: subcontractInvoiceColNm.Loc,
    flex: 1,
  },
  {
    field: 'TrnsAmnt',
    headerName: "ค่าขนส่ง",
    width: 110,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'OwnRcptAmnt',
    headerName: "ค่าขนส่งอื่นๆ",
    width: 110,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'CusRcptAmnt',
    headerName: "ค่าใช้จ่ายล่วงหน้า",
    width: 120,
    align: "right",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: 'Total',
    headerName: subcontractInvoiceColNm.Total,
    width: 110,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: "WhtPr",
    headerName: subcontractExpenseColNm.WhtPr,
    width: 90,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
  {
    field: "PayAmnt",
    headerName: subcontractExpenseColNm.PayAmnt,
    width: 100,
    align: "right",
    valueGetter: (params) => +params.row.Total - +params.row.WhtPr,
    valueFormatter: (params) => params.value ? numberFormat(+params.value) : "0.00",
  },
]

export const printColumnHeader = [
  {
    id: "No",
    name: "No",
    prompt: "No.",
    width: 0.4,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "ScInvNo",
    name: "ScInvNo",
    prompt: "เลขที่ใบแจ้งหนี้",
    width: 1.7,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "AptTm",
    name: "AptTm",
    prompt: "วันที่เข้า รง.",
    width: 1,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "Loc",
    name: "Loc",
    prompt: "สถานที่",
    width: 2.8,
    align: "center",
    padding: 0,
    separateRow: "#TEXT#"
  },
  {
    id: "ContNo",
    name: "ContNo",
    prompt: "หมายเลขตู้",
    width: 1.2,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "TrnsAmnt",
    name: "TrnsAmnt",
    prompt: "ค่าขนส่ง",
    width: 1,
    align: "right",
    padding: 0,
    separateRow: "#SUM#"
  },
  {
    id: "OwnRcptAmnt",
    name: "OwnRcptAmnt",
    prompt: "อื่นๆ",
    width: 0.8,
    align: "right",
    padding: 0,
    separateRow: "#SUM#"
  },
  {
    id: "CusRcptAmnt",
    name: "CusRcptAmnt",
    prompt: "คจ.ล่วงหน้า",
    width: 1,
    align: "right",
    padding: 0,
    separateRow: "#SUM#"
  },
]
